import React from 'react';

const problems = [
  {
    icon: '🧠',
    title: 'Charge mentale',
    desc: 'Difficile de se souvenir de tous les détails importants de vos relations',
    color: 'bg-red-50 border-red-200',
  },
  {
    icon: '🟡',
    title: 'Réseaux passifs',
    desc: 'Les plateformes actuelles ne favorisent pas les interactions authentiques',
    color: 'bg-yellow-50 border-yellow-200',
  },
  {
    icon: '🛡️',
    title: 'Solution KORA',
    desc: 'Outil privé, éthique et intelligent avec IA intégrée et conformité RGPD',
    color: 'bg-blue-50 border-blue-200',
  },
];

function About() {
  return (
    <section className="bg-[#f7fafd] py-20 px-4 md:px-0" id="about">
      <h2 className="text-3xl font-bold text-blue-900 text-center mb-4">Pourquoi KORA ?</h2>
      <p className="text-center text-blue-700 max-w-2xl mx-auto mb-10">
        Face aux réseaux sociaux passifs et à la charge mentale du networking, KORA offre une solution privée, éthique et intelligente.
      </p>
      <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">
        {problems.map((p) => (
          <div key={p.title} className={`rounded-2xl border ${p.color} p-6 flex flex-col items-center shadow-sm`}>
            <span className="text-3xl mb-2">{p.icon}</span>
            <h3 className="font-semibold text-blue-900 mb-1">{p.title}</h3>
            <p className="text-blue-700 text-center text-sm">{p.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default About; 